import {Btn, H5} from "../../../../../AbstractElements";
import React, {useContext, useState} from "react";
import {Card, CardBody} from "reactstrap";
import SweetAlert from "sweetalert2";
import axiosConfig from "../../../../../Config/axios";
import {getApplicationRoute} from "../../../../../Route/RouteIndex";
import Loader from "../../../../../Layout/Loader";
import AuthorizationContext from "../../../../../_helper/Authorization";
import type {AuthorizationContextType} from "../../../../../_helper/Authorization/AuthorizationTypes";

interface walletFixAmountFormProps {
    price: number
    impactorID: number
    actorID?: number
    callBack?: () => void
    transactionType?: string
}

const WalletFixAmountForm = ({price, impactorID, callBack,actorID, transactionType = 'transaction-type-point-purchase-collector-participant'}: walletFixAmountFormProps) => {
    const [loaderVisibility, setLoaderVisibility] = useState(false);
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const {errorHandler} = authContext || {};

    const openConfirmAlert = (amount: number) => {
        SweetAlert.fire({
            title: 'Do you want to buy',
            text: 'Once you purchase you cannot undo!',
            icon: 'warning',
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonText: 'Buy',
            cancelButtonText: 'cancel',
        })
            .then((result: { value: any; }) => {
                if (result.value) {
                    processTransaction(amount)
                }
            })
    }

    const processTransaction = (amount: number) => {
        setLoaderVisibility(true);
        const params = {
            amount: amount,
            impactor_id: impactorID,
            actor_id: actorID,
            transaction_type: transactionType,
        };
        axiosConfig
            .post(`${getApplicationRoute('double-entry-wallet-transaction')}`, params)
            .then((response: { data: { data: any; }; }) => {
                if (response?.data?.data) {
                    callBack && callBack();
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception);
                setLoaderVisibility(false);
            });
    }
    return <Card className="text-center pricing-simple ">
        <Loader visibility={loaderVisibility}/>
        <CardBody>
            <H5>{price?.toLocaleString('en-LK', {
                style: 'currency',
                currency: 'LKR',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}</H5>
        </CardBody><Btn attrBtn={{size: "lg", color: "primary", onClick: () => openConfirmAlert(price)}}>
        <H5 attrH5={{className: "mb-0"}}>Buy</H5></Btn>
    </Card>
}

export default WalletFixAmountForm;